<footer>
    <div>CitiusTech Inc. 2018 - All Rights Reserved</div>
    <div><img src="./assets/imgs/logo.png" class="img-fluid"></div>
</footer>